// Course plan links are stored per course in the backend `product.course_plan`
// column (admin panel → Products) and snapshotted into `users.course_plan`
// when a contract is saved. The backend is authoritative; these helpers only
// read/display the value.

export const COURSE_PLAN_LABEL = "Դասընթացի իրականացման տևողությունը, ժամկետը և ծրագիրը:";

// Accepts both API (snake_case) and form/state (camelCase) shapes.
export const getCoursePlan = (record) => {
    if (!record || typeof record !== "object") return "";
    const value = record.course_plan ?? record.coursePlan ?? "";
    return typeof value === "string" ? value.trim() : "";
};

// Only plain web links are ever rendered as <a href> / PDF links.
export const isSafeHttpUrl = (value) => {
    if (!value || typeof value !== "string") return false;
    try {
        const url = new URL(value);
        return url.protocol === "http:" || url.protocol === "https:";
    } catch {
        return false;
    }
};

// Resolves the course plan link for a course name (the value stored in
// selectedCourse / selected_course, i.e. product.name).
export const findCoursePlan = (products, courseName) => {
    if (!Array.isArray(products) || !courseName) return "";
    const product = products.find((p) => p?.name === courseName);
    const plan = getCoursePlan(product);
    return isSafeHttpUrl(plan) ? plan : "";
};
